// vue babel plugin doesn't support pragma replacement
import { mdx } from '@mdx-js/vue'
let h;
/* @jsxRuntime classic */
/* @jsx mdx */
import PostHeader from "@/components/PostHeader";
import Media from "@/components/Media";
import BlogGallery from "@/components/BlogGallery";
import Button from "@/components/Button";


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PostHeader title='A Digital Agency with a Different Format' snippet='' projectName='Nuvem' imageName='nuvem/nuvem.jpeg' date='2014 - 2018' stack='(Javascript, PHP, MySQL, Wordpress, HTML, CSS)' order='6' mdxType="PostHeader" />
    <p>{`Initially founded as S-link, Nuvem was a digital agency focused on website and software development. At Nuvem, besides developing projects, I was also responsible for the customer service and sales part. Nuvem was a very important experience for me, as it was where I learned to work with web development and also where I learned to sell and deal with clients.`}</p>
    <p>{`I participated in several projects at Nuvem, but I will highlight here the ones I liked the most to work on:`}</p>
    <div class={'blogGallery'}>
    <p><span class='green'>2017 Project:</span> Re-branding and e-commerce development.</p>
    <Media src='/work/nuvem/venezapiscinas.jpeg' mdxType="Media" />
    <Media src='/work/logos/veneza-comparing.png' mdxType="Media" />
    <div class='buttonGroup'>
        <Button href='https://s-linkweb.com.br/Planejamento_Veneza_Piscinas-2017-2.pdf' target='_blank' mdxType="Button">Re-branding Document</Button>
        <Button class='outlined' href='https://loja.venezapiscinas.com.br' target='_blank' mdxType="Button">Visit Store</Button>
    </div>
    <p><span class='green'>2017 Project:</span> Branding and website and study platform development.</p>
    <Media src='/work/nuvem/hooeduca.jpeg' mdxType="Media" />
    <p><span class='green'>2017 Project:</span> Re-branding and website and e-commerce development.</p>
    <Media src='/work/nuvem/barra-nova-magazine.jpeg' mdxType="Media" />
    <div class='buttonGroup'>
        <Button href='https://loja.barranovamagazine.com.br' target='_blank' mdxType="Button">Visit Store</Button>
        <Button class='outlined' href='https://barranovamagazine.com.br' target='_blank' mdxType="Button">Visit Website</Button>
    </div>
    <p><span class='green'>2016 Project:</span> Branding and website development.</p>
    <Media src='/work/nuvem/entre-becos.jpeg' mdxType="Media" />
    <p><span class='green'>2016 Project:</span> Branding and website development.</p>
    <Media src='/work/nuvem/js.jpeg' mdxType="Media" />
    <p><span class='green'>2016 Project:</span> Branding and website development.</p>
    <Media src='/work/nuvem/ciranda-sertaneja.jpeg' mdxType="Media" />
    <p><span class='green'>2015 Project:</span> Branding and website development.</p>
    <Media src='/work/nuvem/samueu.jpeg' mdxType="Media" />
    <p><span class='green'>2015 Project:</span> Branding and website development.</p>
    <Media src='/work/o-andarilho-clemente/main-page.jpeg' mdxType="Media" />
    </div>
    <div class="blogGallery mosaic">
    <p>Some branding only projects:</p>
    <Media class='fullWidth' src='/work/logos/kanboom.png' mdxType="Media" />
    <Media class='fullWidth' src='/work/logos/hermit.png' mdxType="Media" />
    <Media src='/work/logos/Apollo.png' mdxType="Media" />
    <Media src='/work/logos/as-contabilidade.png' mdxType="Media" />
    <Media src='/work/logos/simple.png' mdxType="Media" />
    <Media src='/work/logos/samuel-blog.jpeg' mdxType="Media" />
    <Media src='/work/logos/sii-saude.jpeg' mdxType="Media" />
    <Media src='/work/logos/sii-saude-post.png' mdxType="Media" />
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  inject: {
    $mdxComponents: {
      default: () => () => ({})
    }
  },
  computed: {
    components() {
      return this.$mdxComponents()
    }
  },
  render(createElement) {
    h = mdx.bind({ createElement, components: this.components })
    return MDXContent({ components: this.components })
  }
}
   